module.exports = __webpack_public_path__ + "img/item-20.bd5fce47.svg";